<article class="subscription">
  @if (!isChangingSubscription) {
    <section class="subscription-info">
      <div class="existing-info">
        <div>
          <div class="label"><strong>Status</strong></div>
          <div>Aktivt siden {{ product.existingSubscription.activeSince | date: 'dd.MM.yyyy' }}</div>
        </div>
        <div>
          <div class="label"><strong>Bruker av abonnement</strong></div>
          <div>{{ product.existingSubscription.userName }}</div>
        </div>
        <div>
          <div class="label"><strong>SIM-kort</strong></div>
          <div>{{ product.existingSubscription.msisdn }}</div>
        </div>
      </div>
      <div class="buttons">
        <a
          class="small-card-button"
          data-testid="change-mbb-subscription-link"
          tabindex="0"
          (click)="changeSubscription(product)"
          (keydown.enter)="changeSubscription(product)"
        >
          <div class="button-text">Endre abonnement</div>
          <mat-icon class="card-arrow" [svgIcon]="IconNames.ice_chevron_right" />
        </a>
      </div>
    </section>
  }
  @if (isChangingSubscription) {
    <app-change-mbb-subscription [mbbProduct]="product" (finishedSelection)="changeSubscriptionClose()" />
  }
</article>
